<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Uczestnicy Programu Karta Mieszkańca</v-flex>

        <v-spacer></v-spacer>
      </v-layout>

      <v-layout row wrap justify-center>
        <v-flex xs11>
          <v-form @submit.prevent="searchBy">
            <v-layout row wrap>
              <v-flex xs12>
                <v-flex text-xs-right>
                  <v-btn
                    large
                    color="error"
                    class="mx-3"
                    @click="showAddModal"
                  >DODAJ UCZESTNIKA PROGRAMU</v-btn>
                </v-flex>

                <h2 class="mx-3 mt-3">Wyszukaj uczestnika Programu</h2>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 md6 lg3 class="px-3">
                <w-schema :model="$schema.login">
                  <v-text-field
                    name="login"
                    label="Adres e-mail"
                    :disabled="!!$schema.$model.pesel || !!$schema.$model.phoneNumber || !!$schema.$model.cardNumber"
                  ></v-text-field>
                </w-schema>
              </v-flex>

              <v-flex xs12 md6 lg3 class="px-3">
                <w-schema :model="$schema.pesel">
                  <v-text-field
                    name="pesel"
                    label="Numer PESEL"
                    :disabled="!!$schema.$model.login || !!$schema.$model.phoneNumber || !!$schema.$model.cardNumber"
                  ></v-text-field>
                </w-schema>
              </v-flex>

              <v-flex xs12 md6 lg3 class="px-3">
                <w-schema :model="$schema.phoneNumber">
                  <v-text-field
                    name="phoneNumber"
                    label="Numer telefonu"
                    :disabled="!!$schema.$model.pesel || !!$schema.$model.login || !!$schema.$model.cardNumber"
                  ></v-text-field>
                </w-schema>
              </v-flex>

              <v-flex xs12 md6 lg3 class="px-3">
                <w-schema :model="$schema.cardNumber">
                  <v-text-field
                    name="cardNumber"
                    label="Numer karty"
                    :disabled="!!$schema.$model.pesel || !!$schema.$model.phoneNumber || !!$schema.$model.login"
                  ></v-text-field>
                </w-schema>
              </v-flex>

              <v-flex xs12 md12 lg12 text-xs-center text-md-right>
                <v-btn type="submit" large color="success mx-3">Wyszukaj</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </material-card>

    <profile-modal :show="addModalVisible" @close="hideAddModal" @save="saveProfile"></profile-modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { WSchema, schemaMixin } from '@witkac/vuetify-components';
import { ProfileType } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import ProfileModal from './modals/Profile.modal';
import schema from '@/schemas/search.schema';
import { notificationsMixin } from '@/mixins/notifications';
import { eventCardReaderMixin } from '@/mixins/eventCardReader';
import { methodsMixin } from '@/mixins/methods';
// @vuese
// @group Client-Search
export default {
  mixins: [schemaMixin, notificationsMixin, eventCardReaderMixin, methodsMixin],
  schema,
  components: {
    MaterialCard,
    MaterialTable,
    ProfileModal,
    WSchema
  },
  data() {
    return {
      model: {},
      addModalVisible: false
    };
  },
  methods: {
    // @vuese
    // Tworzy profil klienta serwisu
    // @arg `data` Dane profilu pochodzące z modala
    saveProfile(data) {
      this.$store
        .dispatch('profiles/add', this.deepClone(data))
        .then(() => {
          this.notifySuccess('Pomyślnie dodano profil klineta');
          this.hideAddModal();
        })
        .catch(err => {
          err.graphQLErrors[0]
            ? this.notifyError('Wystąpił błąd podczas dodawania profilu klienta', [err.graphQLErrors[0].message])
            : this.notifyError('Wystąpił błąd podczas dodawania profilu klienta');
          console.warn(err);
        });
    },
    // @vuese
    // Sprawdza jaki parametr został podany, a następnie wywołuje funkcję wyszukania po podanym parametrze
    searchBy() {
      const type = ProfileType.CLIENT;
      if (this.$schema.$model.login) {
        this._searchBy('profiles/findByEmail', { email: this.$schema.$model.login, type });
      }
      if (this.$schema.$model.pesel) {
        this._searchBy('profiles/findByPESEL', { pesel: this.$schema.$model.pesel, type });
      }
      if (this.$schema.$model.phoneNumber) {
        this._searchBy('profiles/findByPhoneNumber', { phoneNumber: this.$schema.$model.phoneNumber, type });
      }
      if (this.$schema.$model.cardNumber) {
        this._searchBy('profiles/findByCardNumber', { cardNumber: this.$schema.$model.cardNumber, type });
      }
    },
    // @vuese
    // Wyszukuje użytkownika po odpowieniej danej
    // @arg `method` Nazwa metody ze store
    // @arg `search` Parametr po którym jest wyszukiwany
    async _searchBy(method, search) {
      try {
        const id = await this.$store.dispatch(method, search);
        this.$router.push({ name: 'client', params: { id } });
      } catch (error) {
        this.notifyError('Nie znaleziono uczestnika.');
        console.warn('ERRROR HANDLER', error);
      }
    },
    // @vuese
    // Funkcja służy do ukrywania modala
    hideAddModal() {
      this.addModalVisible = false;
    },
    // @vuese
    // Funkcja służy do pokazywania modala
    showAddModal() {
      this.addModalVisible = true;
    },
    // @vuese
    // Funkcja otrzymuje numer karty z cardReadera i wyszukuje klienta po nim
    // @arg `cardNumber` Numer karty z eventListenera
    cardReaderHandler(cardNumber) {
      this.$schema.$model.cardNumber = cardNumber;
      this.searchBy();
    }
  }
};
</script>
